import { Select } from '@inflearn/ds-react';

import useNextUrlState from '../../hooks/useNextUrlState';

interface UrlStateSelectProps<T> {
  options: { label: string; value: T }[];
  defaultValue?: string;
  isMobile?: boolean;
}

export function UrlStateSelect<T extends string>({
  options,
  defaultValue,
  isMobile = false,
}: UrlStateSelectProps<T>) {
  const { value: query, fetchQuery } = useNextUrlState<{
    sort?: T;
  }>();

  const handleChange = (sort: T) => {
    fetchQuery({ sort });
  };

  return (
    <Select
      data={options}
      defaultValue={(defaultValue || query.sort) ?? options[0].value}
      onChange={handleChange}
      ml="auto"
      styles={{ input: { paddingRight: 35 } }}
      size={isMobile ? 'md' : 'sm'}
    />
  );
}
